import styles from "./YourLocation.module.scss";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import markSvg from "../../assets/images/your-location/mark.svg";
import Autocomplete from "../../components/shared/Autocomplete/Autocomplete";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const EnterYourLocation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnContinue = () => {
    navigate("/select-plan");
  };

  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.content}>
          <img className={styles.image} src={markSvg} alt="mark" />
          <h2 className={styles.title}>{t("EnterYourLocation")}</h2>
          <p className={styles.text}>{t("EnterYourLocationHelpYou")}</p>
          <div className={styles.wrapper}>
            <Autocomplete />
            <CustomButton
              text={t("Continue")}
              type={"button"}
              typeStyle={"fill"}
              functionOnClick={handleOnContinue}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterYourLocation;
